<template>
  <div class="filter-cost">
    <InputFilter
      :value="computeCost"
      :placeholder="$t('placeholder.cost')"
      :clearable="false"
      :default-store-value="null"
      :is-readonly-now="show"
      action-name="search/SET_COST"
      @clicked="show = true"
    />
    <el-dialog
      class="cost-modal filter-modal-wrapper"
      :visible.sync="show"
      width="300px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :center="true"
      :lock-scroll="true"
      :show-close="false"
    >
      <ModalCost :cost-val="searchCost" @clicked="chooseCost" />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InputFilter from '~/components/Common/InputFilter'
import ModalCost from '~/components/Search/Modals/Cost'

export default {
  name: 'Cost',
  components: {
    ModalCost,
    InputFilter
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapGetters({
      searchCost: 'search/searchCost',
      currencySign: 'user/getCurrencySign'
    }),
    computeCost() {
      if (this.searchCost) {
        return `${this.currencySign}${this.searchCost[0]} - ${this.searchCost[1]}`
      } else return ''
    }
  },
  methods: {
    chooseCost() {
      this.show = false
    }
  }
}
</script>

<style scoped lang="scss">
.cost-modal {
  margin-top: calc(40vh - 100px) !important;
}
</style>
